module.exports = __webpack_public_path__ + "img/banner2.cbd2aa4e.jpg";